const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWingRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 480,
    viewBox: "0 0 443 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KRILO-desno") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M116.9,312.9c-6.1,6.7-31.4,7-31.5,7.4-2.5,31.8,56.4,14.5,49.6,6.3-2.6-1.4-3.7-12.4-3.4-16.2C129.5,313.3,122.9,315.4,116.9,312.9Z",
    style: {
      fill: "#ffea00",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.7,323.5c-7.4,9.2-34.5,16.2-34.6,16.7-4.8,37,61.9,2.2,54.6-5.5-2.9-1-3.5-13.2-3-17.7C158.2,320.8,150.5,324.8,143.7,323.5Z",
    style: {
      fill: "#ffea00",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5,280.3c-16.8,7-26.5-2.8-30.2,3.8-20.3,35.7,66.6,39.3,63.1,25.8C123.6,303.3,98.7,286.4,92.5,280.3Z",
    style: {
      fill: "#ffea00",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.2,337.5c-.2,7.5-21.4,19.8-21.1,20.1,21.5,22.7,58.5-17.2,46.7-19.5-3.3.3-12.3-6.6-15-9.4C175.1,331.7,171.1,336.2,164.2,337.5Z",
    style: {
      fill: "#ffea00",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.5,282c-15.2,6.3-23.8-2.4-27.2,3.5C56,317.2,134,320,131,308,129.4,302.2,107.1,287.3,101.5,282Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.8,311.9c-4.7,5.1-23.8,5.6-23.8,6-2.3,23.9,42.3,10.2,37.3,4.1-1.9-1-2.6-9.2-2.4-12.2C133.3,312,128.4,313.7,123.8,311.9Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,325.9c-5.2,6.4-24.1,11.1-24.1,11.5-3.2,25.8,43.3,1.9,38.2-3.5-2-.7-2.5-9.3-2.2-12.4C150.2,324,144.9,326.8,140.1,325.9Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.7,335.6c-.3,6-15.4,16.4-15.2,16.7,14.7,18,41.3-15,33-16.6-2.3.3-8.5-5.1-10.3-7.3C173.5,330.7,170.6,334.5,165.7,335.6Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.1,353c-1.2-11.8-11.3,4.9-12.2,5.8,30.8,43.2,65.8-12.3,52.9-20.7.8.9-7.6,19.6-14.9,23.1C167.1,364.4,154.5,367.2,148.1,353Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.8,338.2c-4.4,15.4-37.8,25.4-42,6.6-3.9-2.9-9.5,2.8-9.8,3.7-4.7,12.2,17.1,22.9,43.1,11.9C146.8,358,168.7,342.2,149.8,338.2Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,321.2c-13.5,27.7,47,38.7,64.9,13.1,5-1.6-38.9,9.9-43.3-13.6C78.7,319.9,63,320.7,63,321.2Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6,282.4c-2.7-11.7-35-.2-31.2,17.6,4.6,25.4,36.1,30.9,70.9,19.3,11.8-9.2-8.8.2-27.2-7.5C64.4,307,59.9,291.4,63.6,282.4Z",
    style: {
      fill: "#0b63e9",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.8,342.4c2,2.7-13.6,26.8-21.9,24.4C159.6,381.1,196.1,358.4,187.8,342.4Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3,328.7c-7.1,19.4,32.1,24.3,46.9,7.8,1.7,1.7-33.1,7.4-35.7-8.8C83.9,324,73.4,328.4,73.3,328.7Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5,283.9c-2.3-10.4-20.1.8-16.8,16.6,4.8,24.6,35.8,23.3,57,18.6,10.3-8.2-10.4,2.2-26.5-4.6C58.9,310.6,57.3,291.9,60.5,283.9Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.1,330.2c2.2,3-15.2,29.2-24.5,26.7C123.5,372.4,164.3,347.6,155.1,330.2Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3,295.4c2.7-5.3,2.2-10.7-3.8-10.5-2.1.4-5,2.6-5.2,10.4-.2,6.5,3.1,12.4,4.6,13.9C56.7,321.9,43.1,305.7,48.3,295.4Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,333.8c-2.5-4.7-6.7-6.9-9.5-2.2-.7,1.8-.6,5.1,5,9,4.7,3.3,10.5,3.6,12.4,3.2C102.2,340.1,83.6,342.7,78.8,333.8Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.9,354.6c-3.5-2.9-7.7-3.8-8.8-.1-.1,1.4.9,3.7,6.8,5.6a20.63,20.63,0,0,0,11.6.3C132.9,355.5,117.6,360.2,110.9,354.6Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4,367c-3.9-1.3-7.6-.6-7.1,3.1.4,1.3,2.1,2.9,7.5,2.4,4.6-.4,8.5-2.8,9.5-3.9C180.5,359.8,169.8,369.4,162.4,367Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.3,278.6c-17.7,7.5-18.1,1.7-26.3,1.5-8.8-.2-21.4-8.8-29-2-12.4,11,5.8,24.9,13.3,20.5-8.5,19.3,7.9,29.2,25.4,22.8-6,5.6-2.1,34.7,26,15.8-3.4,11.8,26.7,22.8,29-3.4,18.6-11,21.4-13,22.5-26.6C201.2,294.6,158.6,271.8,142.3,278.6Z",
    style: {
      fill: "#cc200a",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.9,281.3c-13.7,6-13.5.6-19.9,1-7.8-.1-11.7-4.2-17.2,1.5-8.9,9.2,6,18.9,11.5,15-5.4,15.5,7.9,22.1,21,16.1-4.3,4.7.4,27,21,10.7-1.9,9.3,22,16.1,22.2-4.4,13.8-9.6,15.8-11.3,15.8-21.9C191.2,289.9,148.6,277.1,138.9,281.3Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.8,287a67.45,67.45,0,0,0-8.1-3.5c-5.1-1.9-9.1-3.6-14-3.7-7.8-.1-16.4,1.9-21.9,7.6-8.9,9.2,6.9,20.9,12.4,17.1-5.4,15.5,5.5,18.4,17.1,7.3-1.6,7.4-2.6,26.6,23.4,16.4-.2.4-.4.9-.3,1,.7.5,17-13.3,14.5-24.4C194.4,297.9,186,293.7,172.8,287Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWingRight);
export default __webpack_public_path__ + "static/media/wing-right.56b19e07792a9c88b54e3c0250209342.svg";
export { ForwardRef as ReactComponent };